import React from 'react';
import styled from '@benzinga/themetron';
import { TestimonialCard, TestimonialData } from '../TestimonialCard';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import { SplideStyle } from '@benzinga/ui';

export interface TestimonialSliderProps {
  data: TestimonialData[];
  enableTruncateText?: boolean;
}

export const TestimonialSlider: React.FC<TestimonialSliderProps> = ({ data, enableTruncateText }) => {
  const containerClassname = `testimonial-carousel ${SplideStyle.splide_slidewrap}`;

  return (
    <TestimonialSliderWrapper className={containerClassname}>
      <Splide
        aria-label="Testimonial Carousel"
        hasTrack={false}
        options={{
          arrows: false,
          breakpoints: {
            576: {
              perPage: 1,
            },
          },
          gap: '1em',
          pagination: false,
          perPage: 2,
        }}
      >
        <SplideTrack>
          {Array.isArray(data) &&
            data.map((item, index) => {
              return (
                <SplideSlide key={`testimonial-carousel-item-${index}`}>
                  <TestimonialCard
                    className="slider-testimonail"
                    data={item}
                    enableTruncateText={enableTruncateText}
                    key={index}
                  />
                </SplideSlide>
              );
            })}
        </SplideTrack>
      </Splide>
    </TestimonialSliderWrapper>
  );
};

export const TestimonialSliderWrapper = styled.div`
  .slider-testimonail {
  }
`;
